__turbopack_context__.v({
  "closeBtn": "Survey-module__3cChBq__closeBtn",
  "survey": "Survey-module__3cChBq__survey",
});
